export const AXIS_TICK_OFFSET = 140;
export const EXTERNAL_FOREIGN_OBJECT_REFERENCE = 'http://www.w3.org/1999/xhtml';
export const AXIS_TICK_VERTICAL_CONFORT_OFFSET = 15;
export const AXIS_BOTTOM_LEGEND = 'Number of participants';
export const AXIS_TICK_HORIZONTAL_PADDING = 5;
